import { Image } from '@codes/ui-kit/components/ui/image';

import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@codes/ui-kit';

import { PdfViewContent } from './sub-components/pdf-view-content';

export const PdfItem = ({ fileUrl }: { fileUrl: string | undefined }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <button type="button" className="w-14 h-14 rounded border flex items-center justify-center bg-white">
                    <Image className="w-9" src="/assets/icons/pdf.svg" darkSrc="/assets/icons/pdf.svg" />
                </button>
            </DialogTrigger>
            <DialogContent className="p-0">
                <DialogTitle />

                <PdfViewContent url={fileUrl} />
            </DialogContent>
        </Dialog>
    );
};
